var OfferPage = require("src/client-ts/containers/Estimation/OfferPage/Pro/OfferPage");
var PremiumOfferPage = require("src/client-ts/containers/Estimation/OfferPage/Premium/PremiumOfferPage");

exports.premiumOfferPage = PremiumOfferPage.PremiumOfferPage;
exports.newOfferPage = OfferPage.OfferPage;
